import React, { createContext, useContext, useEffect, useState } from 'react';
import { Transaction, TransactionResponse } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';
import { AuthContext } from '../auth';
import moment from 'moment';




type TransactionsContextProps = {
    transactions: Transaction[];
    totalPage: number;
    isLoading: boolean;
    loadTransactions:  ( page: number, startDate, endDate, merchant_id, transaction_id ) => Promise<void>;
    /*addTransaction: ( categoryId: string, transactionName: string ) => Promise<Transaction>;
    updateTransaction: ( categoryId: string, transactionName: string, transactionId: string ) => Promise<void>;
    deleteTransaction: ( id: string ) => Promise<void>;
    loadTransactionById: ( id: string ) => Promise<Transaction>;*/
   
}



export const TransactionsContext = createContext({} as TransactionsContextProps);



export const TransactionsProvider = ({ children }: any ) => {

    const [transactions, setTransactions] = useState<Transaction[]>([]);
    const [totalPage, setTotalPage] = useState<number>(0);
    const [isLoading, setIsLoading] = useState<boolean>(false);
     const {user} = useContext(AuthContext);
    const pageSize = 15;
    

    

    useEffect(() => {
        loadTransactions(0, moment().format("YYYY-MM-DD"), moment().add(1, 'day').format("YYYY-MM-DD"), -1, -1);
    }, [])


    const loadTransactions = async(pageActual, startDate, endDate, merchantid, transaction_id) => {

        setIsLoading(true);
        var merchantCode;

        if(user.groups[0].group_name.toLowerCase() == "backoffice" 
        ||user.groups[0].group_name.toLowerCase() == "administrator"){
            merchantCode = merchantid;
        }else{
            merchantCode =  user.merchants.length > 0 ? user.merchants[0].merchant_id : -1
        }

        if(transaction_id == '')
            transaction_id = -1

        const req = {
            "merchantCode": merchantCode,
            "startDate": startDate,
            "endDate": endDate,
            "pageIndex": pageActual,
            "pageSize": pageSize,
            "transactionId": transaction_id 
        }

        const resp = await topApi.post<TransactionResponse>('/transaction/bymerchant', req);
        setTransactions([ ...resp.data.transactions ]);
        setTotalPage(resp.data.pages);
        setIsLoading(false);

    }

    
    return(
        <TransactionsContext.Provider value={{
            transactions,
            totalPage,
            isLoading,
            loadTransactions,
        }}>
            { children }
        </TransactionsContext.Provider>
    )
}